import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../common/Button"
import InputBox from "../../../common/interactive/InputBox"
import PannelBody from "../../../fragments/PannelBody"
import { caseQuickUpdate,  insuranceCarrierLocationCreate, insuranceCarrierLocationUpdate, selectInsurance } from "../../../../lib/fetchApi"
import { buildEntityFormContact } from "../../../../lib/countyResolution"
import { countiesOptions } from "../../../../lib/systemData"
import { useContactCountyConfirmation } from "../../../patient/page/countyMismatchConfirm"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"
import { attorneyActions } from "../../../../store/attorneys"
import PannelFooter from "../../../fragments/PannelFooter"
import ContactInformation from "./Parts/ContactInformation"

import classes from './Create.module.css'
import { isCompletePhone, isEmail } from "../../../../lib/validation"

const GeneralCreateLocationForm = ({closeModal, itemData, edit, folder, apiCase}) => {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)

    const activeCase = useSelector(state => state.case.activeCase)
    const { confirmCountyOnSave, modal: countyMismatchModal } = useContactCountyConfirmation()

    const createLawFirmHandler = async (event) => {
        event.preventDefault()
        setIsLoading(true)

        try {
            const fd = new FormData(event.target)

            const data = Object.fromEntries(fd.entries())

            let errors = []
                                    
            if (data && data.email && !isEmail(data.email)) {
                errors.push('Please check Email Field')
            } 

            if (data && data.phone && !isCompletePhone(data.phone)) {
                errors.push('Please check Phone Field')
            }

            if (data && data.cell_phone && !isCompletePhone(data.cell_phone)) {
                errors.push('Please check Cell Phone Field')
            }

            if (data && data.fax && !isCompletePhone(data.fax)) {
                errors.push('Please check Fax Field')
            }

            if (errors && !errors.length) {
                const originalContact = edit ? itemData?.location?.contact_information : null
                const formContact = buildEntityFormContact(data)
                const countyResult = await confirmCountyOnSave({
                    token: userToken,
                    originalContact,
                    formContact,
                    selectedCountyId: data.county,
                    countiesOptions,
                })

                if (countyResult?.error) {
                    dispatch(notificationActions.setError(countyResult.error))
                    return
                }

                if (countyResult.cancelled) {
                    return
                }

                const body = {
                    // name: data.location_name,
                    insurance_carrier_id: itemData.insurance_carrier_id,
                    contact_information: {
                        email: data.email,
                        phone: data.phone,
                        cell_phone: data.cell_phone,
                        phone_2: null,
                        phone_3: null,
                        phone_ext: data.ext,
                        fax: data.fax,
                        address_1: data.address_line_1,
                        address_2: data.address_line_2,
                        city: data.city,
                        state: data.state,
                        county_id: countyResult.countyId,
                        zip: data.zip_code
                    }
                }
            
                let loc;
                if (edit) { //edit api
                    loc = await insuranceCarrierLocationUpdate(userToken, itemData.location_id, body)
                } else { //create api
                    loc = await insuranceCarrierLocationCreate(userToken, body)
                }

                if (loc?.errorMessage) {
                    dispatch(notificationActions.setError(loc))     
                } else {            
                    // close modal:
                    closeModal()

                    const body = {
                        folder: folder, 
                        item: {
                            itemId: itemData.id,
                            fields: [
                                {
                                    field: 'location_id',
                                    value: loc?.id
                                },
                                {
                                    field: 'location',
                                    value: loc
                                }
                            ]              
                        },
                    }


                    dispatch(caseActions.modifyActiveCaseMultiple(body))
                    dispatch(attorneyActions.setCreatedlocation(loc))

                    //need to re make the all reps array
                    let repsFromInsurance =  await selectInsurance(userToken, itemData.insurance_carrier_id)
                    dispatch(caseActions.setAllRepsOnItem({
                        item_id: itemData.id,
                        folder: folder,
                        content: repsFromInsurance
                    }))

                    // if it is not on edit modes, need to bind the created entity to the law firm
                    if (!edit) {
                        let reqBody = {
                            type: apiCase,
                            type_id: itemData.id, 
                            fields: {
                                location_id : loc?.id,
                            }
                        }
                        const update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)
                        if (update?.errorMessage) {
                            dispatch(notificationActions.setError(update))     
                        } else {
                            dispatch(notificationActions.setError({errorMessage: 'Binded to law firm', type:'success'}))
                            
                        }
                    }
                }
            } else {
                dispatch(notificationActions.setError({errorMessage : errors}))
            }
        } finally {
            setIsLoading(false)
        }
    }

    return <form onSubmit={createLawFirmHandler}>
        {countyMismatchModal}
        <PannelBody padding='large' background={'var(--line-transparent)'}>
            <div className={classes.subtitle}>
                Assigned Insurance Carrier
            </div>
            {itemData.insurance_carrier.name}
        </PannelBody>
        {/* <PannelBody padding='large'>
            <InputBox label="Location name" type="text" name="location_name" required={true} placeholder="" currentValue={edit ? itemData.location.name : null}/>
        </PannelBody> */}
        <ContactInformation edit={edit} itemData={itemData} informationType={'location'} requireIdentifier={'attorney_location'} loading={(value) => setIsLoading(value)}/>
        <PannelFooter>
            <Button type='submit' isLoading={isLoading} width={'full'}>
                Submit 
                <i className="ti ti-chevron-right"></i>
            </Button>
        </PannelFooter>
    </form>
}

export default GeneralCreateLocationForm